<script>
export default {
  name: "ClockIcon",
  props: {
    color: {
      type: String,
      default: "currentColor",
    },
  }
};
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none" role="img" aria-label="Ícone de relógio">
    <title>Ícone de relógio</title>
    <path
      d="M9.08333 4.08333V9.08333L12.4167 10.75M17.4167 9.08333C17.4167 13.6857 13.6857 17.4167 9.08333 17.4167C4.48096 17.4167 0.75 13.6857 0.75 9.08333C0.75 4.48096 4.48096 0.75 9.08333 0.75C13.6857 0.75 17.4167 4.48096 17.4167 9.08333Z"
      :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>